import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import patchStream from './base/patchStream';
import postStream from './base/postStream';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Add station API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  addStation: (data: any, handleUploadProgress: (progress: any) => void): Promise<any> => {
    return postStream(
      `${config.commonApiUrl}api/facility/v2/charging-station`,
      data,
      true,
      handleUploadProgress,
    );
  },
  /**
   * Fetch stations API
   * @param query
   */
  fetchStations: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-station`, {
      ...parameters,
    });
  },
  /**
   * Fetch stations API for export
   * @param query
   */
  fetchStationsExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-station/export-data`, {
      ...parameters,
    });
  },
  /**
   * Fetch all stations API
   * @param query
   */
  fetchAllStations: () => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-station/station-names`, {});
  },
  /**
   * Fetch all stations details API
   * @param query
   */
  fetchAllStationDetails: () => {
    return getRequest(
      `${config.commonApiUrl}api/facility/v1/charging-station/station-all-details`,
      {},
    );
  },
  /**
   * Edit station API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  editStation: (
    id: string,
    data: any,
    handleUploadProgress: (progress: any) => void,
  ): Promise<any> => {
    return patchStream(
      `${config.commonApiUrl}api/facility/v2/charging-station/${id}`,
      data,
      true,
      handleUploadProgress,
    );
  },
  /**
   * Edit station status API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  editAvailableStatusStation: (id: string, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/facility/v1/charging-station/status/${id}`,
      data,
      false,
    );
  },
  /**
   * Delete Station API
   * @param id
   */
  deleteStation: (id: string): Promise<any> => {
    return deleteRequest(`${config.commonApiUrl}api/facility/v1/charging-station/${id}`);
  },

  /**
   * Fetch approved station API
   * @returns
   */
  fetchListFilters: () => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-station/list-filters`);
  },
  /**
   * Fetch the charging station list with pagination
   */
  fetchChargingStationByStationId: (id: string): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/charging-station/${id}`);
  },
  /**
   * Fetch the charging station list with pagination
   */
  fetchChargingPointByStationId: (id: string): Promise<any> => {
    return getRequest(
      `${config.commonApiUrl}api/facility/v1/charging-point/station/device-details/${id}`,
    );
  },
  /**
   * Fetch the facility details
   * @param facilityId - facility id
   * @returns - facility details
   */
  fetchFacilityDetails: (facilityId: string): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/facility-tag/${facilityId}`);
  },
};
